import { Icon, Text } from '@kanda-libs/ks-design-library';

interface ViewComponentProps {
  /**
   * Buullet points
   */
  bullets?: string[];
}

const ViewComponent = ({ bullets }: ViewComponentProps) => (
  <div className="flex flex-col mb-8">
    {bullets &&
      bullets.map((bullet) => (
        <div key={bullet} className="flex flex-row mb-2 last:mb-0">
          <div className="flex bg-lavender-100 h-6 w-6 min-w-6 min-h-6 rounded-full mr-2 md:mr-3">
            <Icon
              icon="check"
              size={12}
              className="m-auto"
              stroke="lavender-300"
            />
          </div>
          <Text
            text={bullet}
            className="mt-0.5 text-12-18-em md:text-14-22-em text-lavender-200"
          />
        </div>
      ))}
  </div>
);

ViewComponent.displayName = 'Checkout-Mobile-Bullets-view';

ViewComponent.defaultProps = {
  bullets: [],
};

export default ViewComponent;
